import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BlogPostContentPlaceholderInterface } from 'common/types/entities/BlogPostContentPlaceholderInterface'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createBlogPostContentPlaceholder(
  parentId: string,
  masterBlockId?: MasterBlockId,
) {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.BlogPostContentPlaceholder,
      parentId,
      masterBlockId,
    ),
    type: EntityTypeEnum.BlogPostContentPlaceholder,
    padding: {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    },
    mobilePadding: {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    },
    isReadOnly: false,
    childIds: [],
  } as BlogPostContentPlaceholderInterface
}
